import { compose, branch, renderNothing, withProps } from 'recompose';
import { CategoriesWidget } from './CategoriesWidget';
import withDeviceInfo from '../../viewport/withDeviceInfo';

const enhance = compose(
    withDeviceInfo,
    branch(({ categoryList }) => !categoryList, renderNothing),
    withProps(({ categoryList, userDevice }) => ({
        categories: categoryList || null,
        isMobileUser: userDevice === 'mobile',
    })),
);

export default enhance(CategoriesWidget);
